import { Input, Modal, Segmented } from 'antd';
import { useState } from 'react';
import { useCreateLibraryItem, useUpdateLibraryItem } from '../../hooks/useWorkLibrary';
import type { SkillLevel } from '../../types';

/** Label + (manpower-only) skill segmented — create/update resource masters via hooks. */
export function ResourceItemEditorModal({
  kind, mode, initial, onClose,
}: {
  kind: 'manpower' | 'machine';
  mode: 'create' | 'edit';
  initial?: { id: string; label: string; skillLevel?: SkillLevel };
  onClose: () => void;
}) {
  const [label, setLabel] = useState(initial?.label ?? '');
  const [skill, setSkill] = useState<SkillLevel>(initial?.skillLevel ?? 'unskilled');
  const create = useCreateLibraryItem();
  const update = useUpdateLibraryItem();
  const busy = create.isPending || update.isPending;
  const save = () => {
    const payload = kind === 'manpower' ? { payload: { skillLevel: skill } } : {};
    if (mode === 'create') {
      create.mutate({ kind, label: label.trim(), visibility: 'org', ...payload }, { onSuccess: onClose });
    } else if (initial) {
      update.mutate({ id: initial.id, input: { label: label.trim(), ...payload } }, { onSuccess: onClose });
    }
  };
  return (
    <Modal open title={mode === 'create' ? `Add ${kind === 'manpower' ? 'labor type' : 'machine'}` : 'Edit item'}
      okText={busy ? 'Saving…' : 'Save'} okButtonProps={{ disabled: busy || label.trim().length < 2 }}
      onOk={save} onCancel={onClose}>
      <div className="space-y-2">
        <Input autoFocus value={label} maxLength={80} onChange={(e) => setLabel(e.target.value)} />
        {kind === 'manpower' && (
          <Segmented<SkillLevel> block value={skill} onChange={setSkill}
            options={[{ value: 'skilled', label: 'Skilled' }, { value: 'unskilled', label: 'Unskilled' }]} />
        )}
      </div>
    </Modal>
  );
}
